import type { TTopBarVariant } from '@/types/top-bars'

export function topBarStateKey(variant: TTopBarVariant, id: number | string): string {
  return `${variant}:${id}`
}

export function formatTopBarEndsOn(date: string | null): string {
  if (!date) {
    return ''
  }

  const parsed = new Date(`${date}T00:00:00`)
  if (Number.isNaN(parsed.getTime())) {
    return ''
  }

  return parsed.toLocaleDateString('en-GB', { day: 'numeric', month: 'long' })
}
